var wPage = document.querySelector('.wishlist-page');
var bodyPage = document.querySelector('body');

if (wPage && window.location.pathname.includes("wishlist")) {
  wPage.classList.add('loading-page');
  bodyPage.style.overflow = 'hidden';
  // Trigger the transition to full opacity
}
document.addEventListener('DOMContentLoaded', function () {
  var link = document.createElement('link');
  link.href =  window.customAccountCSSUrl;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.media = "all";
  document.head.appendChild(link);
  //end add css
  var wishlistContent = document.createElement('div');
  wishlistContent.className = 'row';
  wishlistContent.innerHTML = `
    <div class="column main col-lg-9 col-md-9 col-sm-12 col-xs-12 pull-right">
    </div>
    <div class="sidebar sidebar-main col-lg-3 col-md-3 col-sm-12 col-xs-12">
      <div class="block account-nav">
        <div class="block-title account-nav-title">
          <h3 class="title">Account Navigation<i class="pe-7s-angle-down"></i>
          </h3>
        </div>
        <div class="content account-nav-content" id="account-nav">
          <ul class="nav items">
            <li class="nav item current">
            <a href="/account">My Account</a>
            </li>
            <li class="nav item">
              <a href="/pages/orders">My Orders</a>
            </li>
            <li class="nav item">
              <strong>My Favorite</strong>
            </li>
            <li class="nav item">
              <span class="delimiter"></span>
            </li>
            <li class="nav item">
              <a href="/account/addresses/">Address Book</a>
            </li>
            <li class="nav item">
              <a href="/pages/edit-account">Account Information</a>
            </li>
            <li class="nav item">
              <span class="delimiter"></span>
            </li>
            <li class="nav item">
              <a href="/pages/newsletter-subscription/">Newsletter Subscriptions</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="sidebars sidebar-additional">
        <div class="block block-wishlist" data-bind="scope: 'wishlist'">
          <div class="block-title">
            <strong class="title">
              My Favorite
              <span class="counter">(<span class="number  wishlist-total-count"></span> <span>items</span>)</span>
            </strong>
          </div>
          <div class="block-content">
            <div class="wishlist-sidebar">
              <div sidebar-wishlist=""></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  if(!document.querySelector(".customer.account,.customer.order,.customer.addresses,.storecredit-container,.page-orders,.tmp-account ")){

    function addHead (){
      const newDiv = document.createElement('div');

      // Set the inner HTML of the new div to include the h1 and span elements
      let transMyFavoriteText = document.getElementById('trans-my-favorite').innerText;
      newDiv.innerHTML = `
        <h1 class="page-header" style="padding-left: 16px; margin-bottom:0">
          <span class="base" data-ui-id="page-title-wrapper">${transMyFavoriteText}</span>
        </h1>
      `;

      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.insertBefore(newDiv, mainContent.firstChild);
      }
    }

    var intervalId = setInterval(function() {
        var transQuickShop = document.getElementById('trans-my-favorite-quick-shop').innerText;
        var wishlistPage = document.querySelector('.wishlist-page');
        var wishlistPageContain = document.querySelector('#wishlist-page-contain');
        var wishlistRow = document.querySelector('.wishlist-row');
        var wishlistSidebar = document.querySelector('.wishlist-sidebar');
        var countI =  document.querySelector('.sidebar-additional .counter .number');
        if (wishlistPageContain && document.querySelector('.wishlist-page')) {
          var wishlistRows = document.querySelectorAll(".wishlist-column");
          //trigger remove
          document.querySelectorAll('.wh-grid-layout .wishlist_page_remove_product').forEach(button => {
            button.addEventListener('click', function() {
              const parentId = this.closest('.wishlist-column').id;
              console.log(parentId);
              setTimeout(() => {
                document.querySelector(`.wishlist-sidebar #${parentId}`).remove()
              },1000)
          });
        });


          wishlistRows.forEach(function(row) {
              // Check if the quickshop button already exists
              if (!row.querySelector('.quickshop-button')) {
                  var wishlistTopDiv = row.querySelector(".wishlist-top");

                  if (wishlistTopDiv) {
                    var infoInnerDiv = document.createElement("div");
                    infoInnerDiv.className = "info-inner"

                      var button = document.createElement("button");
                      button.innerText = transQuickShop;
                      button.className = "quickshop-button"; // Add a class for styling if needed
                      button.addEventListener("click", function() {
                        var handle = getHandleFromHref(row);
                        if (handle) {
                            setupGrid(handle);
                        }
                    });
                      infoInnerDiv.appendChild(button);
                      wishlistTopDiv.appendChild(infoInnerDiv);
                  }
              }
          });
        var quickshopContainer = document.querySelector(".quickshop-container");

        if (!quickshopContainer &&  document.querySelector(".wh-grid-layout")) {
          var div = document.createElement("div");
          div.className = "quickshop-container"; // Add a class for styling if needed
          document.querySelector(".wh-grid-layout").appendChild(div);
      }


          // Append wishlistContent to .wishlist-page

          document.querySelector('.wishlist-page').appendChild(wishlistContent);

          //new: query wishlistSidebar after appended wishlistContent
          wishlistSidebar = wishlistContent.querySelector('.wishlist-sidebar') || document.querySelector('.wishlist-page .wishlist-sidebar');

          //new: guard to prevent crash if there is no sidebar/row
          if (!wishlistSidebar || !wishlistRow) {
            return;
          }

          let itemN = document.querySelectorAll(`.wishlistajaxLoad .wishlist-column`).length;
          if(countI) countI.innerHTML = itemN

          // Add 'customer' and 'account' classes to .wishlist-page
          wishlistPage.classList.add('customer', 'account');

          // Move #wishlist-page-contain into .column.main
          document.querySelector('.column.main').appendChild(wishlistPageContain);

          // Clone wishlist-row and append to wishlist-sidebar
          var clonedWishlistRow = wishlistRow.cloneNode(true);
          wishlistSidebar.appendChild(clonedWishlistRow);

          addHead()
          wPage.classList.remove('loading-page');
          bodyPage.style.overflow = 'auto';


          // Function to add event listeners to the wishlist-row

          function updateItemCount() {
            let itemCount = document.querySelectorAll('#wishlist-page-contain .wishlist-column').length;
            let counterElement = document.querySelector('.block-title .number');
            if (counterElement) {
                counterElement.innerText = itemCount;
            }
        }
          function addEventListenersToWishlistRow(row) {
            const addToCartButtons = row.querySelectorAll('button.wishlist-cart');
            // Add event listener to the "Add to cart" button
            addToCartButtons.forEach(addToCartButton => {

              if (addToCartButton) {
                  // Translation
                  addToCartButton.innerText = document.getElementById('trans-add-to-cart').innerText;
                  addToCartButton.addEventListener('click', function(event) {
                      event.stopPropagation();  // Prevent triggering the row's click event
                      // Your add to cart action here
                      const productId = this.getAttribute('data-product_id');
                      const variantId = this.getAttribute('data-variant_id');
                      const quantity = this.getAttribute('data-quntity');
                      document.querySelector(`#wishlist-page-contain .wishlist-cart[data-product_id='${productId}']`).click()
                      console.log(`Add to cart clicked for product ${productId} with variant ${variantId}, quantity ${quantity}`);
                      setTimeout(() => {
                        this.closest(".wishlist-column").remove();
                        updateItemCount();
                    }, 1700);
                  });
              }
            });

          }

          addEventListenersToWishlistRow(clonedWishlistRow);




        clearInterval(intervalId); // Stop the interval once the element is found and content is added
      }
    }, 1000); // Check every second (1000 ms)
  }
  const isLoggedIn = !!document.getElementById('wishlist-engine-customer-records');
  if (!isLoggedIn) {
    document.body.classList.add('guest-customer');
  }
 
});
function scrollToQuickshop() {
  const quickshopContainer = document.querySelector('.quickshop-container');

  if (quickshopContainer) {
    const elementPosition = quickshopContainer.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - 170; // 30px offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  } else {
    console.error('Element .quickshop-container not found.');
  }
}
function addQuickshopRemove() {
  var div = document.querySelector(".quickshop-container");
   // Add the remove button
   var removeButton = document.createElement("button");
   removeButton.className = "quickshop-remove";
   removeButton.id = "quickshop-remove";

   removeButton.innerHTML = `<svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M2.276.39L12 10.115 21.724.391c.486-.486 1.254-.519 1.777-.098l.108.098c.521.52.521 1.364 0 1.885L13.886 12l9.723 9.724c.521.52.521 1.365 0 1.885-.52.521-1.364.521-1.885 0L12 13.886l-9.724 9.723c-.486.486-1.254.519-1.777.098l-.108-.098c-.521-.52-.521-1.364 0-1.885L10.114 12 .391 2.276C-.13 1.756-.13.911.39.391.91-.13 1.755-.13 2.276.39z" id="close__a"></path></defs><use xlink:href="#close__a" fill-rule="evenodd"></use></svg>`;
   removeButton.addEventListener("click", function() {
       div.innerHTML = "";
   });
   div.appendChild(removeButton);

}

function getHandleFromHref(row) {
  var anchor = row.querySelector("a[href*='/products/']");
  if (anchor) {
      var url = new URL(anchor.href);
      //var handle = url.pathname.split('/products/')[1];
      var handle = url.pathname;
      return handle ? handle.split('?')[0] : null;
  }
  return null;
}

var setupGrid = function(handle) {
  let grid = document.querySelector(".quickshop-container");

  const requests = function(handle) {
    // let handle1 = "seagull-embroidery-cargo-pants-2esgnm3po249lfcn"
    var productTileTemplateUrl = handle;
    console.log(productTileTemplateUrl, 'productTileTemplateUrl');

    return fetch(productTileTemplateUrl).then(function(res) {
      return res.text();
    });
  }

  console.log(requests, 'requests');
  document.body.classList.add('loading');
  // Ensure requests is called with the handle and the returned promise is in an array
  Promise.all([requests(handle)]).then(function(responses) {
    var wishlistProductCards = responses.join('');
    if(grid) {
      let template = document.createElement('div');
      template.innerHTML = wishlistProductCards;
      let productTemplate = Array.from(template.querySelectorAll('[id^="MainProduct-template--"]')).find(el => el.id.endsWith('__main'));

      if (productTemplate) {
        grid.innerHTML = productTemplate.outerHTML;

        qsDisablePdpLinksInSwatches(grid);

        // Re-apply after variant re-render (theme may rebuild swatch HTML)
        if (!grid.dataset.qsReapplyNoPdp) {
          grid.dataset.qsReapplyNoPdp = '1';
          grid.addEventListener(
            'change',
            () => setTimeout(() => qsDisablePdpLinksInSwatches(grid), 0),
            true
          );
        }


        grid.querySelectorAll('variant-selects, variant-radios').forEach((el) => {
          el.dataset.updateUrl = 'false';
          el.dataset.url = handle;
        });

        let moreDetailsDiv = document.createElement('div');
        let transMoreDetailText = document.getElementById('trans-more-detail').innerText;
        moreDetailsDiv.className = 'box-more-details';
        moreDetailsDiv.innerHTML = `
          <a target="_parent" title="${transMoreDetailText}" href="${handle}">
            <span>${transMoreDetailText}<i class="icon-arrow_down"></i></span>
          </a>
        `;

        // Find the product-infor tag and append the new div
        let productInfo = grid.querySelector('product-info');
        console.log(11,productInfo)
        if (productInfo) {
          productInfo.appendChild(moreDetailsDiv);
        }
      } else {
        grid.innerHTML = wishlistProductCards; // Fallback to the entire content
      }

      // Make sure the content fills the full page
      grid.style.width = "100%";
      grid.style.height = "100%";
      addQuickshopRemove();
      setTimeout(() => {
        scrollToQuickshop()
      },300)

      // Extract and execute scripts
      let scripts = grid.querySelectorAll('script');
      scripts.forEach(script => {
        let newScript;

        // Check if the script is a data-holding script or a regular one
        if (script.type === 'application/json') {
          // Preserve the JSON script tags in the grid
          newScript = document.createElement('script');
          newScript.type = script.type;
          newScript.innerHTML = script.innerHTML;
          newScript.id = script.id;  // Keep the same ID if it has one
          newScript.dataset = script.dataset; // Preserve any data attributes
          const vHost = grid.querySelector('variant-radios, variant-selects') || grid;
          vHost.appendChild(newScript);
        } else {
          // Handle executable scripts
          newScript = document.createElement('script');
          if (script.src) {
            newScript.src = script.src;
            newScript.defer = script.defer;
          } else {
            newScript.innerHTML = script.innerHTML;
          }
          document.body.appendChild(newScript);
        }

        script.remove(); // Remove the original script tag to avoid duplicates
      });


      // ✅ Re-init color filter AFTER meta/scripts are available
      setTimeout(() => {
        if (window.evisuInitProductGalleryColorFilter) {
          window.evisuInitProductGalleryColorFilter(grid);
        }
      }, 50);

    }
    document.body.classList.remove('loading');
  }).catch(function(error) {
    console.error('Error loading product data:', error);
  });
};

const observer = new MutationObserver(() => {
    if (document.querySelector('.pswp--open')) {
      bodyPage.style.overflow = 'hidden';
    } else {
      bodyPage.style.overflow = 'auto';
    }
});

observer.observe(bodyPage, { childList: true, subtree: true });

function qsDisablePdpLinksInSwatches(grid) {
  if (!grid || grid.dataset.qsNoPdpLinks === '1') return;
  grid.dataset.qsNoPdpLinks = '1';

  // 1) Rewrite href trong khu vực variant (đây mới là chặn redirect thật)
  grid
    .querySelectorAll('variant-radios a[href*="/products/"], variant-selects a[href*="/products/"]')
    .forEach((a) => {
      if (a.dataset.qsHrefDone === '1') return;
      a.dataset.qsHrefDone = '1';
      a.dataset.qsOriginalHref = a.getAttribute('href') || '';
      a.setAttribute('href', '#');
      a.setAttribute('role', 'button');
    });

  // 2) Chặn click/pointerdown chỉ cho link /products/ trong swatch
  function blockIfProductLink(e) {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || !grid.contains(a)) return;

    const isInVariantArea = !!a.closest('variant-radios, variant-selects');
    if (!isInVariantArea) return;

    // allow link "more details" của bạn
    if (a.closest('.box-more-details')) return;

    const original = a.dataset.qsOriginalHref || a.getAttribute('href') || '';
    const isProductLink = original.indexOf('/products/') !== -1;
    if (!isProductLink) return;

    e.preventDefault();
    e.stopPropagation(); // KHÔNG dùng stopImmediatePropagation
    console.log('[QS] blocked PDP link from swatch:', original);
  }

  grid.addEventListener('pointerdown', blockIfProductLink, true);
  grid.addEventListener('click', blockIfProductLink, true);
}

/* ===========================
 * QS PATCH: Cart drawer fallback when response.sections is missing
 * =========================== */
(function qsPatchCartDrawerRenderContents() {
  if (window.__qsCartDrawerPatched) return;
  window.__qsCartDrawerPatched = true;

  if (!window.customElements?.whenDefined) return;

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__qsPatched) return;
    CartDrawer.prototype.__qsPatched = true;

    const original = CartDrawer.prototype.renderContents;

    CartDrawer.prototype.renderContents = async function (parsedState) {
      try {
        // ✅ If /cart/add.js response doesn't include sections -> fetch them
        if (!parsedState || !parsedState.sections) {
          const sections = (this.getSectionsToRender?.() || [])
            .map((s) => s.section || s.id)
            .filter(Boolean);

          if (sections.length) {
            const root = window.Shopify?.routes?.root || '/';
            const url = `${root}?sections=${encodeURIComponent(sections.join(','))}`;
            const res = await fetch(url, { credentials: 'same-origin' });
            const data = await res.json();
            parsedState = Object.assign({}, parsedState, { sections: data });
          }
        }
      } catch (e) {
        console.warn('[QS] cart drawer fallback failed:', e);
      }

      return original.call(this, parsedState);
    };
  });
})();

